export const SPHERE_RADIUS = 1000
export const SITE_CAMERA_DELAY = 750
export const DEFAULT_IOS_ZOOM = 90
export const DEFAULT_WEB_ZOOM = 120
export const DEFAULT_ZOOM_TWEEN = 0.3
export const CAMERA_DISTANCE_TO_TARGET = 0.1
export const MAX_FOV = (120 * Math.PI) / 180 // Maximum FOV allowed in radians (horizontal or vertical)
export const DEFAULT_SITE_TWEEN_DURATION = 2
